import amplitudeExperimentService from '@/services/amplitude/amplitude-experiment.service'
import {
  EebPlacementVariant,
  ExperimentFlags,
} from '@/services/amplitude/experiment-flags'

/**
 * Returns true when the user is assigned to the EEB placement experiment's
 * variant B (`mainscreen`) — EEB booking is removed from onboarding and shown
 * as a mainscreen task.
 *
 * Fail-safe: if the Experiment SDK is not initialized or the user is not
 * assigned, `variant()` returns null and we treat the user as control (A).
 */
const isMainscreenVariant = (): boolean =>
  amplitudeExperimentService.variant(ExperimentFlags.EebPlacement) ===
  EebPlacementVariant.Mainscreen

/**
 * Returns true when the user is *explicitly* assigned to the control variant A
 * (`wizard`) — EEB booking stays a required onboarding step.
 *
 * This is distinct from "unknown" (`variant()` returns null while the fetch is
 * pending, or after a teardown reset): an explicit control assignment
 * means the mainscreen must never reconstruct the variant-B EEB experience, even
 * if the backend journey still contains a pending EEB task.
 */
const isControlVariant = (): boolean =>
  amplitudeExperimentService.variant(ExperimentFlags.EebPlacement) ===
  EebPlacementVariant.Wizard

export default { isMainscreenVariant, isControlVariant }
